import * as React from 'react';
import { useState, useEffect } from 'react';
import SystemAlerts from 'src/component/SystemAlerts';
import System from 'src/helper/system';
import { useForecastStore } from 'src/hooks/forecast';
import useReduxState from 'src/hooks/useReduxState';
import { Pagination } from 'src/reusable/global';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Helper from 'src/support/Helper';
import $ from "jquery";
import "floating-scroll";
import { useSelector } from 'react-redux';
import stickyTableCommon from 'src/helper/stickyTableCommon';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';

const ForecastTable = (props) => {

    const [__check] = useAxiosIndicatorCheck();
    const [forecastListData, setForecastListData] = useState([]);
    const [forecastDetailListData, setForecastDetailListData] = useState([]);
    const [{ forecast_list, forecast_detail_list, forecast_date_columns, forecast_open_accordion_list, forecast_counts }, { get_forecast_data }, { set_open_accordion_list }] = useForecastStore();
    const [forecastSearch] = useReduxState('', 'setForecastSearch')
    const [forecastSearchCpnStatus] = useReduxState('', 'setForecastSearchCpnStatus')
    const [firstServerCall] = useReduxState(true, 'setFirstServerCall')
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    // const [clickedSearch] = useReduxState(false, 'setClickedSearch')
    const [clickedSearch, setClickedSearch] = useReduxState(false, 'setClickedSearch')
    const [searchError, setSearchError] = useState({
        isError:false,
        message:'',
        type:''
    });
    const [show, setShow] = useState(true); // flag decides visibility of table
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });

    useEffect(() => {
        window.scrollTo({ top: 0 });
        if (firstServerCall === false && !monitorFunctionCall) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [forecastListData])

    useEffect(() => {
        setTimeout(() => {
            $(".floating-table").floatingScroll("init");
        }, 2000)
    }, [axios_indicator]);
    useEffect(() => {
        setForecastListData(forecast_list)
        setForecastDetailListData(forecast_detail_list)

        if (forecastSearch.length < 2 && clickedSearch === true) {
            setSearchError({isError:true,message:'Please enter at least 2 characters to execute a keyword search.',type:'info'})
        } else if (Object.entries(forecast_list).length <= 0 && forecastSearch.length >= 2) {
            setSearchError({isError:true,message:'We couldn\'t find any forecast for <b class="text-black">"' + forecastSearch + '"</b>.',type:'info'})
        } else if (Object.entries(forecast_list).length <= 0) {
            setSearchError({isError:true,message:'We couldn\'t find any forecast',type:'info'})
            // setSearchError(true)
            // System.alert("We couldn't find any forecast", 'info');
        } else {
            // setSearchError(false)
            setShow(true);
            setSearchError({isError:false})
        }
        const total = getCount(forecastSearchCpnStatus)
        setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })

    }, [forecast_list])

    const getCount = (status) => {
        if (status.key === '') {
            return forecast_counts.total
        } else if (status.key === 'G') {
            return forecast_counts.nonConstraint
        } else if (status.key === 'R') {
            return forecast_counts.constraint
        }
        return forecast_counts.total
    }

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                /**
                 * display error msg if less then 2 character in search
                 * Author: Devanshi Patel
                 */
                if (forecastSearch.trim().length < 2 && clickedSearch === true) {
                    setSearchError({isError:true,message: 'Please enter at least 2 characters to execute a keyword search.',type:'info'})
                } else {
                    await fetchAPICall()
                    setShow(true);
                    setSearchError({isError:false})
                    // setSearchError(false)
                }
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [forecastSearch])

    useEffect(() => {
        const getList = async () => {
            await defaultPageActive()
        };
        getList()
    }, [listObj.pageCount])

    useEffect(() => {
        const getList = async () => {
            if (listObj.page === 1) {
                await fetchAPICall()
            } else {
                await defaultPageActive()
            }
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [forecastSearchCpnStatus, listObj.limit])

    useEffect(() => {
        const getList = async () => {
            setTimeout(async () => {
                await fetchAPICall();
            }, 500);
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.page]);

    useEffect(() => {
        const getList = async () => {
            await fetchAPICall();
        };
        if (firstServerCall === false) {
            getList()
        }
    }, [listObj.sortBy, listObj.sortOrder])

    const defaultPageActive = async () => {
        setListObj({ ...listObj, page: 1 })
    }

    const handlePageClick = async (data) => {
        let here_page = 0
        here_page = data.selected + 1;
        setListObj({ ...listObj, page: here_page })
        Helper.scrollTop();
    };

    const setPageLimit = async (event) => {
        await setListObj({ ...listObj, limit: event.target.value })

    };

    const fetchAPICall = async () => {
        await get_forecast_data({
            "searchKeyword": forecastSearch.trim(),
            "cpnStatus": forecastSearchCpnStatus && forecastSearchCpnStatus.key,
            "pageNumber": listObj.page,
            "pageSize": listObj.limit,
            "sortBy": listObj.sortOrder,
            "sortOrder": listObj.sortBy,
        })
    };

    useEffect(() => {
        if (forecastSearch.length < 2 && clickedSearch === true) {
            setSearchError({isError:true,message:'Please enter at least 2 characters to execute a keyword search.',type:'info'})
        } else {
            setSearchError({isError:false})
        }
    }, [clickedSearch])

    const get_forecast_detail_by_id = (id) => {
        const filtered = Object.keys(forecastDetailListData)
            .filter(key => key === id)
            .reduce((obj, key) => {
                obj[key] = forecastDetailListData[key];
                return obj[key];
            }, {});

        if (filtered && Object.entries(filtered).length > 0) {
            return (
                Object.entries(filtered).map((v, i) => (
                    <tr key={i} className={getClassForForecastColumns(i, v, filtered)}>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className='bg-grey'><div className='expanded-tr-title'>{
                            v[0].toLocaleLowerCase() === 'openorderquantity' ? 'OPEN ORDER QUANTITY' :
                                v[0].toLocaleLowerCase() === 'shippingquantity' ? 'SHIPPED QUANTITY' :
                                    v[0].toLocaleLowerCase() === 'pipelinequantity' ? 'Pipeline QUANTITY' :
                                        v[0].toLocaleLowerCase() === 'consignedreplenishmentquantity' ? 'Consigned Replenishment Qty' :
                                            v[0].toLocaleLowerCase() === 'shippedconsignedreplenishmentquantity' ? 'Shipped consigned replenishment Qty' :
                                                v[0].toLocaleLowerCase() === 'availablebufferquantity' ? 'Available buffer Quantity' :
                                                    v[0].toLocaleLowerCase() === 'runningtotal' ? 'Running Total' : ''
                        }</div></td>
                        <td></td>
                        {v[1] && Object.entries(v[1]).length > 0 &&
                            Object.entries(v[1]).map((j, i) => (
                                <td key={i}><span>{parseInt(j[1])}</span></td>
                            ))
                        }
                    </tr>
                ))
            )

        }
    }

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})
        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField})
        }
        setListObj({ ...listObj, sortBy: columnName,sortOrder:listObj.ascDesField[columnName] })
    };

    /**
     * CR #      : 7073
     * Change #  : Below function will hide the consigned replenishment & shipped consigned replenishment column if data is blank
     * Change by : Pankaj
     * Date      : 27 Feb 2023
     */
    const getClassForForecastColumns = (index, row, filter) => {
        let elemClass = 'align-middle expanded-tr';
        if (index === Object.entries(filter).length - 1) {
            elemClass = 'align-middle expanded-tr last'
        }
        if (row &&
            (row[0].toLocaleLowerCase() === 'shippedconsignedreplenishmentquantity' ||
                row[0].toLocaleLowerCase() === 'consignedreplenishmentquantity') &&
            (row[1] === undefined || Object.keys(row[1]).length === 0)) {
            elemClass += ' d-none'
        }
        return elemClass;
    }

    /**
     * Ticket #  : 10890
     * Change    : Sticky header call
     * Change by : Pankaj
     * Date      : 01 Sep,2023 
     */
    useEffect(() => {
        let callBackResult;
        if (forecastListData && Object.entries(forecastListData).length > 0) {
            callBackResult = stickyTableCommon('forecast-table', toggleOrderBy);
        }
    }, [forecastListData, __check(['FORECAST_API_CALL']).status])

    const onClose = () => {
        setShow(false);
        setClickedSearch(false)
    }
    return (
        <>
            {(__check('FORECAST_API_CALL').status || (!searchError?.isError && Object.entries(forecastListData).length > 0)) &&
                <div className='position-relative'>
                    <div>
                        {__check(['FORECAST_API_CALL'], { overlay: true }).render}
                    </div>
                    {show &&
                        <>
                            <div id="sticky-table-wrapper" className="floating-table table-responsive m-t-5 position-relative sticky-table-wrapper">
                                <table id="forecast-table" className="bs5 table table-bordered table-striped table-striped-even forecast-table mb-0 sticky-table-four">
                                    <thead>
                                        <tr>
                                            <th className="w60 minw60"></th>
                                            <th className='w120 minw120'><span>Part Number Status</span>
                                                <span aria-label="ZZCPNSTATUS" className={` ${'sort-container ' + getOrderByClass('ZZCPNSTATUS')}`} onClick={() => { toggleOrderBy('ZZCPNSTATUS') }}></span>
                                            </th>
                                            <th className='w150 minw150'><span>Customer Part Number</span>
                                                <span aria-label="ZZCMA" className={` ${'sort-container ' + getOrderByClass('ZZCMA')}`} onClick={() => { toggleOrderBy('ZZCMA') }}></span>
                                            </th>
                                            <th className='w150 minw150'><span>CPN Last Forecast Date</span>
                                                <span aria-label='LOADDATE' className={` ${'sort-container ' + getOrderByClass('LOADDATE')}`} onClick={() => { toggleOrderBy('LOADDATE') }}></span>
                                            </th>
                                            <th className='w120 minw120'><span>Customer Comments </span>
                                                <span aria-label='CUSTOMER_COMMENT' className={` ${'sort-container ' + getOrderByClass('CUSTOMER_COMMENT')}`} onClick={() => { toggleOrderBy('CUSTOMER_COMMENT') }}></span>
                                            </th>
                                            {
                                                forecast_date_columns && forecast_date_columns.length > 0 &&
                                                forecast_date_columns.map((k, i) => (
                                                    <th key={i} className='w120 minw120'><span>{k}</span></th>
                                                ))
                                            }
                                        </tr>
                                    </thead>
                                    {Object.entries(forecastListData).length > 0 &&
                                        <tbody>
                                            {forecastListData && Object.entries(forecastListData).length > 0 &&
                                                !searchError?.isError && Object.entries(forecastListData).map((v, i) => (
                                                    <React.Fragment key={i}>
                                                        <tr className={forecast_open_accordion_list.includes(v[1].uniqueID) ? 'align-middle action-tr parent' : 'align-middle action-tr'}>
                                                            <td>
                                                                <div className='accordion-white-button'>
                                                                    <div className="accordian-arrow">
                                                                        {
                                                                            forecast_open_accordion_list.includes(v[1].uniqueID) ?
                                                                                <i className="fa fa-angle-double-up me-0 d-block"
                                                                                    onClick={async () => await set_open_accordion_list(v[1].uniqueID)} /> :
                                                                                <i className='fa fa-angle-double-down me-0 d-block'
                                                                                    onClick={async () => await set_open_accordion_list(v[1].uniqueID)} />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='constraint-status-wrapper'>
                                                                    <span>{v[1].partNumberStatus.toLowerCase() === 'g' ? 'Non Constraint' : 'Constraint'}</span>
                                                                    <span className={"constraint-status " + (v[1].partNumberStatus.toLowerCase() === 'g' ? '' : 'constraint-status-red')}>
                                                                        <span></span>
                                                                        <span></span>
                                                                        <span></span>
                                                                    </span>
                                                                </div>
                                                            </td>
                                                            <td>{v[1].customerPartNumber}</td>
                                                            <td>{v[1].cpnLastForecastDate ? Helper.dateFormatFromString(v[1].cpnLastForecastDate, true) : ''}</td>
                                                            <td>{v[1].customerComments}</td>
                                                            {
                                                                v[1].additionalData && Object.entries(v[1].additionalData).length > 0 &&
                                                                Object.entries(v[1].additionalData).map((j, i) => (
                                                                    <td key={i}>
                                                                        <div className='constraint-status-wrapper'>
                                                                            <span>{parseInt(j[1].value)}</span>
                                                                            <span className={"constraint-status " + (j[1].periodStatus.toLowerCase() === 'g' ? '' : 'constraint-status-red')}>
                                                                                <span></span>
                                                                                <span></span>
                                                                                <span></span>
                                                                            </span>
                                                                        </div>
                                                                    </td>
                                                                ))
                                                            }
                                                        </tr>
                                                        {forecast_open_accordion_list.includes(v[1].uniqueID) &&
                                                            get_forecast_detail_by_id(v[1].uniqueID)

                                                        }
                                                    </React.Fragment>
                                                ))}
                                        </tbody>
                                    }
                                </table>
                            </div>
                            <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1} limit={listObj.limit} />
                        </>
                    }
                </div>
            }

            {!__check(['FORECAST_API_CALL']).status && searchError?.isError &&
                <AlertContentWithFlag key={Helper.UUID()} message={searchError?.message} type={searchError?.type} isDisplay={true} isDisplayIcon={false} callBackFunc={onClose} />
                // <SystemAlerts />
            }
        </>
    );
}

export default ForecastTable;